const features = [
  {
    icon: "ri-live-line",
    title: "高清赛事直播",
    description: "4K超清画质，多路信号自由切换，低延迟流畅播放，不错过任何精彩瞬间。",
  },
  {
    icon: "ri-bar-chart-2-line",
    title: "实时数据分析",
    description: "百万级数据支撑，控球率、射门转化率、跑动热力图等专业指标一应俱全。",
  },
  {
    icon: "ri-ai-generate",
    title: "AI智能预测",
    description: "基于深度学习的赛事预测模型，综合分析近况、伤病、天气等因素，准确率高达75%。",
  },
  {
    icon: "ri-notification-3-line",
    title: "智能赛事提醒",
    description: "关注球队比赛自动提醒，重要事件实时推送，绝不错过任何关键节点。",
  },
  {
    icon: "ri-group-line",
    title: "社交观赛体验",
    description: "虚拟观赛房间、实时弹幕互动、赛事竞猜功能，让观赛不再孤单。",
  },
  {
    icon: "ri-device-line",
    title: "全平台覆盖",
    description: "支持安卓全机型、Android 8.0以上系统，折叠屏和平板均有专属适配。",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-display-sm md:text-display-md text-foreground-900 mb-4">
            为什么选择大满贯
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            我们用技术重新定义体育观赛体验，为每一位体育爱好者打造专属的赛事数据平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}